import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React, { useState } from 'react';

import StandardInputComponent from '../form-elements/standard-input';
import SubmitButton from '../form-elements/submit-button';

import { baseTheme } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),

    },
    headerSpacing: {
      marginBottom: theme.spacing(1),
    },
    inputBase: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      borderRadius: '5px',
    },
    contentRoot: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    inputRoot: {
      marginBottom: theme.spacing(1),
      paddingRight: theme.spacing(2),
      position: 'relative',

    },
    buttonContainer: {
      width: '10%',
      position: 'absolute',
      right: theme.spacing(2),
    },
    submitButton: {
      fontSize: '1em',
    },
  }),
);

export default function ForgotInfoForm(props: any) {
  const { resetType, heading, description, sendEmail } = props;
  const classes = useStyles(baseTheme);
  const defaultFormValues = {
    resetType,
    email: '',
  };
  const [formValues, setFormValues] = useState(defaultFormValues);

  const handleChange = (prop: any) => (event: any) => {
    setFormValues({ ...formValues, [prop]: event.target.value });
  };
  const handleSubmit = () => {
    if (typeof sendEmail === 'function') {
      sendEmail(formValues);
    }
  };

  return (
    <Grid container item className={classes.root}>
      <Grid item xs={12} className={classes.contentRoot}>
        <Typography variant="h5" color="primary" className={classes.headerSpacing}>
          {heading}
        </Typography>
        {description}
      </Grid>

      <Grid item xs={12} className={classes.inputRoot}>
        <FormControl variant="filled" className={classes.inputBase}>
          <StandardInputComponent
            id="email"
            label="Email"
            value={formValues.email}
            onChange={handleChange('email')}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} className={classes.inputRoot}>
        <div className={classes.buttonContainer}>
          <SubmitButton
            className={classes.submitButton}
            onClick={handleSubmit}
            text="Submit"
            variant="dark"
          />
        </div>
      </Grid>
    </Grid>
  );
}
